(ns ui.view.card.counterparty-diligence-responder.model)

(def send-to-responder-modal-open-path [:send-to-responder-modal-open?])

(defn send-to-responder-modal-open-full-path
  [card-state-path]
  (into card-state-path send-to-responder-modal-open-path))

(def email-subject-line-path [:email-subject-line])

(defn email-subject-line-full-path
  [card-state-path]
  (into card-state-path email-subject-line-path))

(def email-body-path [:email-body])

(defn email-body-full-path
  [card-state-path]
  (into card-state-path email-body-path))

(def companies-to-check-path [:companies-to-check])

(defn companies-to-check-full-path
  [card-state-path]
  (into card-state-path companies-to-check-path))

(def people-to-check-path [:people-to-check])

(defn people-to-check-full-path
  [card-state-path]
  (into card-state-path people-to-check-path))
